<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="notificationCol()">
        <v-card flat tile>
          <v-toolbar height="46px" color="accent" dark flat>{{notificationName}}</v-toolbar>
            <v-container style="max-height: 330px" class="overflow-y-auto">
              <v-card-text class="grey--text" align="center" v-if="notificationExistFlag">お知らせはありません</v-card-text>
              <v-card-text v-for="(item, key) in notificationNameItems" :key="key">
                <div>
                  <v-chip
                    x-small
                    color="orange"
                    text-color="white"
                    v-if="item.systemInfoFlag"
                    label
                  >システムからのお知らせ</v-chip>
                </div>
                <div>
                  {{ item.create_date }} ({{ item.dayOfWeek }})
                  <v-chip
                    x-small
                    color="red"
                    text-color="white"
                    v-if="item.todayFlag"
                  >New</v-chip>
                </div>
                <div class="font-weight-black">{{ item.title }}</div>
                <div>{{ item.content }}</div>
                <v-divider class="mt-5"></v-divider>
              </v-card-text>
            </v-container>
        </v-card>
      </v-col>
      <v-col :cols="tableCol()" v-if="othersTablesFlag">
        <v-tabs v-model="model" background-color="accent" dark>
          <v-tab href="#constructionInformationtTab">{{constructionInformationtTableName}}</v-tab>
          <v-tab href="#workerDailyReportTab" v-if="workerDisplayFlag" >{{workerDailyReportTableName}}</v-tab>
          <v-tab href="#dailyConstructionReportTab" v-if="displayFlag">{{dailyConstructionReportTableName}}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="model">
          <v-tab-item value="constructionInformationtTab">
            <v-col>
              <custom-data-table :tableName="constructionInformationtTableName" :header="constructionInformationHeaders" :items="constructionInformationItems" :visibleStore="false" :loading="loading" :visibleTop="false">
                <template v-slot:status="{ item }">
                  <v-chip v-show="item.status === constructionInformationStatuses.notReceived.value" color="error" text-color="white">
                    <v-avatar left><v-icon>mdi-pencil-circle</v-icon></v-avatar>{{ constructionInformationStatuses.notReceived.name }}
                  </v-chip>
                  <v-chip v-show="item.status === constructionInformationStatuses.received.value" color="warning" text-color="white">
                    <v-avatar left><v-icon>mdi-circle-slice-8</v-icon></v-avatar>{{ constructionInformationStatuses.received.name }}
                  </v-chip>
                  <v-chip v-show="item.status === constructionInformationStatuses.missing.value" color="grey" text-color="white">
                    <v-avatar left><v-icon>mdi-close-circle</v-icon></v-avatar>{{ constructionInformationStatuses.missing.name }}
                  </v-chip>
                  <v-chip v-show="item.status === constructionInformationStatuses.reflect.value" color="success" text-color="white">
                    <v-avatar left><v-icon>mdi-check-circle</v-icon></v-avatar>{{ constructionInformationStatuses.reflect.name }}
                  </v-chip>
                </template>
              </custom-data-table>
            </v-col>
          </v-tab-item>
          <v-tab-item value="workerDailyReportTab">
            <v-col>
              <custom-data-table :tableName="workerDailyReportTableName" :header="workerDailyReportHeaders" :items="workerDailyReportItems" :visibleStore="false" :loading="loading" :visibleTop="false">
                <template v-slot:status="{ item }">
                  <v-chip v-if="item.status === workerDailyReportStatuses.draughting.value" color="grey" text-color="white">
                    <v-avatar left><v-icon>mdi-pencil-circle</v-icon></v-avatar>{{ workerDailyReportStatuses.draughting.name }}
                  </v-chip>
                  <v-chip v-if="item.status === workerDailyReportStatuses.pending.value" color="warning" text-color="white">
                    <v-avatar left><v-icon>mdi-circle-slice-8</v-icon></v-avatar>{{ workerDailyReportStatuses.pending.name }}
                  </v-chip>
                  <v-chip v-if="item.status === workerDailyReportStatuses.sendBack.value" color="error" text-color="white">
                    <v-avatar left><v-icon>mdi-close-circle</v-icon></v-avatar>{{ workerDailyReportStatuses.sendBack.name }}
                  </v-chip>
                  <v-chip v-if="item.status === workerDailyReportStatuses.approved.value" color="success" text-color="white">
                    <v-avatar left><v-icon>mdi-check-circle</v-icon></v-avatar>{{ workerDailyReportStatuses.approved.name }}
                  </v-chip>
                </template>
              </custom-data-table>
            </v-col>
          </v-tab-item>
          <v-tab-item value="dailyConstructionReportTab">
            <v-col>
              <custom-data-table :tableName="dailyConstructionReportTableName" :header="dailyConstructionReportHeaders" :items="dailyConstructionReportItems" :visibleStore="false" :loading="loading" :visibleTop="false">
              </custom-data-table>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <!-- 利用規約ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="termsDialog" persistent max-width="800">
        <v-card>
          <v-card-title class="headline">
          </v-card-title>
          <v-card-text outlined>
            <iframe class="pdf" v-bind:src="termLink" width="100%" height="630" />
          </v-card-text>
          <v-card-actions>
            <v-spacer>
              <v-col cols="12">
                <v-checkbox class="mb-1" label="利用規約に同意する" v-model="termsAgreeData" @change="termsAgreeChange" hide-details></v-checkbox>
              </v-col>
              <v-row cols="12" justify="center">
                <v-btn  class="mb-8" width="380" large depressed color="primary lighten-1" @click.stop="updateTerms()" :disabled="!termsDisabled" >利用開始</v-btn>
              </v-row>
            </v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import ConstructionApi from "@/api/construction-api";
  import WorkerDailyReportApi from "@/api/worker-daily-report-api";
  import ConstructionDailyReportApi from "@/api/construction-daily-report-api";
  import UserPolicysApi from "@/api/user-policys-api";
  import NotificationsApi from "@/api/notifications-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import statusList from "@/helpers/const";
  import SystemNotificationsListApi from "@/api/system-notifications-api";
  export default {
    name: "Dashboard",
    components: {
      CustomDataTable
    },
    props: ["user"],
    data: () => ({
      //利用規約ダイアログ
      termsDialog: false,
      termsItem: [],
      termsDisabled: false,
      termsAgreeData: false,
      implementationDate: "",
      termLink: "",

      // 共通コンポーネント: データテーブル関連
      loading: false,
      notificationName:'お知らせ',
      constructionInformationtTableName: '工事情報',
      workerDailyReportTableName: '作業日報',
      dailyConstructionReportTableName: '工事日報',
      constructionInformationHeaders: [
        { text: "ステータス", value: "status" },
        { text: "工番", value: "construction_number" },
        { text: "工事名", value: "construction_name" },
        { text: "工事場所", value: "place" },
        { text: "工期(自)", value: "start_date" },
        { text: "工期(至)", value: "end_date" },
      ],
      workerDailyReportHeaders: [
        { text: "ステータス", value: "status"},
        { text: "日付", value: "worker_date"},
        { text: "工事名称", value: "construction_name" },
      ],
      dailyConstructionReportHeaders: [
        { text: "日付", value: "worker_date" },
        { text: "工番", value: "construction_number" },
        { text: "工事名称", value: "construction_name" },
      ],
      constructionInformationItems: [],
      workerDailyReportItems: [],
      dailyConstructionReportItems: [],
      notificationNameItems: [],
      constructionInformationStatuses: {
        notReceived: { name: "未受注", value: 0 },
        received: { name: "受注済", value: 1 },
        missing: { name: "失注済", value: 2 },
        reflect: { name: "実績反映済", value: 3 }
      },
      workerDailyReportStatuses: {
        draughting: { name: "下書き", value: 0 },
        pending: { name: "申請中", value: 1 },
        sendBack: { name: "差し戻し", value: 2 },
        approved: { name: "承認済み", value: 3 }
      },
      displayPermission: false,
      workerDisplayFlag: false,
      notificationExistFlag: false,
      displayFlag: false,
      model: 'constructionInformationtTab',
      dayList: ['日','月','火','水','木','金','土'],
      othersTablesFlag: true,
    }),
    created () {
      this.initialize ()
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();

        this.UserPolicysApi = new UserPolicysApi();
        const UserPolicysRes = this.UserPolicysApi.info().then((response) => {
          for (var item of response.data.body.user_policys_info){
            if(item.status === 0){
              if (this.user.role_id === 1) {
                this.termsItem.push(item.content_url);
                this.implementationDate = item.implementation_date;
                this.termsDialog = true;
                if(this.termLink === "") {
                  this.termLink = item.content_url + "#toolbar=0&navpanes=0";
                }
              }
            }
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
        });
        var notificationsRes = null;
        if(this.user.role_id === 2){
          this.systemNotificationsListApi = new SystemNotificationsListApi();
          notificationsRes = this.systemNotificationsListApi.list().then((response) => {
            const array = response.data.body.system_notifications_list;
            this.notificationExistFlag = (array.length === 0) ? true : false;
            const today = this.getToDay();
            array.forEach((item) => {
              const todayFlag = (item.create_date === today) ? true : false;
              const createDate = new Date(item.create_date);
              const dayOfWeek = this.getDayOfWeek(createDate);
              item.todayFlag = todayFlag;
              item.dayOfWeek = dayOfWeek;
              item.systemInfoFlag = (item.category === 1) ? true : false;
              this.notificationNameItems.push(item);
            });
          }).catch(error => {
            useAppInsights().trackException({exception: error});
          });
        }else{
          this.notificationsApi = new NotificationsApi();
          notificationsRes = this.notificationsApi.list().then((response) => {
            const array = response.data.body.notifications_list;
            this.notificationExistFlag = (array.length === 0) ? true : false;
            const today = this.getToDay();
            array.forEach((item) => {
              const todayFlag = (item.create_date === today) ? true : false;
              const createDate = new Date(item.create_date);
              const dayOfWeek = this.getDayOfWeek(createDate);
              item.todayFlag = todayFlag;
              item.dayOfWeek = dayOfWeek;
              item.systemInfoFlag = (item.category === 1) ? true : false;
              this.notificationNameItems.push(item);
            });
          }).catch(error => {
            useAppInsights().trackException({exception: error});
          });
        }
        if (this.user.role_id === 0) {
          this.displayPermission = this.user.permission_config.CTSG00013.display;
          this.displayFlag = this.user.permission_config.CTSG00013.read;
          this.workerDisplayFlag = this.user.permission_config.CTSG00012.read;
        }
        if (this.user.role_id === 2){
          this.othersTablesFlag = false;
        }

        this.constructionApi = new ConstructionApi();
        const constructionRes = this.constructionApi.list().then((response) => {
          for (var item of response.data.body.construction_list) {
            if (item.department_id == this.user.department_id) {
              this.constructionInformationItems.push(item);
            }
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
        });
        var workerDailyReportRes = null;
        if (this.workerDisplayFlag) {
          this.workerDailyReportApi = new WorkerDailyReportApi();
          var workerDailyReportReportPromise = this.workerDailyReportApi.list();
          workerDailyReportRes = workerDailyReportReportPromise.then((response) => {
            this.workerDailyReportItems = response.data.body.worker_daily_report_info;
          }).catch(error => {
            useAppInsights().trackException({exception: error});
          })
        }
        var constructionDailyReportRes = null;
        if (this.displayFlag) {
          this.constructionDailyReportApi = new ConstructionDailyReportApi();
          var constructionDailyReportPromise = this.constructionDailyReportApi.list();
          if (this.displayPermission) {
            constructionDailyReportPromise = this.constructionDailyReportApi.all();
          }
          constructionDailyReportRes = constructionDailyReportPromise.then((response) => {
            this.dailyConstructionReportItems = response.data.body.construction_daily_report_list;
          }).catch(error => {
            useAppInsights().trackException({exception: error});
          });
        }
        Promise.all(
          [
            UserPolicysRes,
            notificationsRes,
            constructionRes,
            workerDailyReportRes,
            constructionDailyReportRes
          ]
        ).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      termsAgreeChange() {
        this.termsDisabled = this.termsAgreeData;
      },
      updateTerms() {
        this.termsDialog = false;
        this.UserPolicysApi = new UserPolicysApi();
        const UserPolicysUpdate = this.UserPolicysApi.update(this.implementationDate);
        UserPolicysUpdate.then((response) => {
          // this.$emit('success', response.data.message);
          console.log(response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
        })
      },
      getToDay() {
        const date = new Date();
        const year = date.getFullYear();
        const month = ("00" + (date.getMonth()+1)).slice(-2);
        const day = ("00" + date.getDate()).slice(-2);
        return year + "/" + month + "/" + day;
      },
      getDayOfWeek(date){
        const day = date.getDay();
        return this.dayList[day];
      },
      notificationCol: function() {
        var result = 4
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            result = 12
            return result;
          case 'sm':
            result = 12
            return result;
          case 'md':
            result = 4
            return result;
          case 'lg':
            result = 4
            return result;
          case 'xl':
            result = 4
            return result;
        }
        return result
      },
      tableCol: function() {
        var result = 8
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            result = 12
            return result;
          case 'sm':
            result = 12
            return result;
          case 'md':
            result = 8
            return result;
          case 'lg':
            result = 8
            return result;
          case 'xl':
            result = 8
            return result;
        }
        return result
      }
    }
  }
</script>

<style scoped>
.pdf embed {
  width: calc(100% - 1px);
}
</style>
